import React from 'react';
import {Route, Routes as RouteList} from "react-router-dom";
import Authenticated from "layouts/Authenticated";
import Dashboard from "pages/Dashboard";
import ZoneList from "pages/Zone/List";
import FacilityList from "pages/Facility/List";
import ExhibitList from "pages/Exhibit/List";
import ExhibitTypeList from "pages/ExhibitType/List";
import FactTemplateList from "pages/FactTemplate/List";
import EventTypeList from "pages/EventType/List";
import MessageList from "pages/Message/List";
import OfferList from "pages/Offer/List";
import FrameList from "pages/Frame/List";
import QrCodeList from "pages/QrCode/List";
import TriggerList from "pages/Trigger/List";
import DocumentList from "pages/Document/List";
import UserList from "pages/User/List";
import SiteList from "pages/Site/List";
import Unauthenticated from "layouts/Unauthenticated";
import {Login} from "pages/Login";
import {TwoFactorAuthChallenge} from "pages/Login";
import Uninitialized from "layouts/Uninitialized";
import OperatorInactive from "pages/OperatorInactive";
import OperatorUnknown from "pages/OperatorUnknown";
import NotFound from "pages/NotFound";
import MutateFactTemplate from "pages/FactTemplate/Mutate";
import MutateExhibitType from "pages/ExhibitType/Mutate";
import MutateUser from "pages/User/Mutate";
import {AchievementList, MutateAchievement} from "pages/Achievement";
import {SiteMap, VisitorLocation} from "pages/Maps/View";
import MutateEventType from "pages/EventType/Mutate";
import MutateZone from "pages/Zone/Mutate";
import MutateFacility from "pages/Facility/Mutate";
import MutateQrCode from "pages/QrCode/Mutate";
import EventSchedule from './Event/Schedule';
import MutateEvent from "pages/Event/Mutate";
import MutateExhibit from "pages/Exhibit/Mutation";
import MutateSite from "pages/Site/Mutate";
import CollectionList from "pages/Collection/List";
import MutateCollection from './Collection/Mutate';
import AudienceSegmentList from "pages/AudienceSegment/List";
import MutateAudienceSegment from "pages/AudienceSegment/Mutate";
import MutateMessage from "pages/Message/Mutate";
import MutateLessonPlan from "pages/LessonPlan/Mutate";
import ViewLessonPlan from "pages/LessonPlan/View";
import MutateFrame from "pages/Frame/Mutate";
import QuizList from "pages/Quiz/List";
import MutateQuiz from "pages/Quiz/Mutate";
import MutateDocument from "pages/Document/Mutate";
import MutateTrigger from "pages/Trigger/Mutate";
import MutateOffer from "pages/Offer/Mutate";
import MutateSettings from "pages/Settings/Mutate";
import ViewCollection from "pages/Collection/View";
import ViewMessage from "pages/Message/View";
import ViewExhibit from "pages/Exhibit/View";
import ViewSite from "pages/Site/View";
import ViewFrame from './Frame/View';
import ViewTrigger from './Trigger/View';
import ViewQuiz from './Quiz/View';
import ViewEvent from "pages/Event/View";
import ViewAudienceSegment from "pages/AudienceSegment/View";
import {
    AppInsights,
    EducationInsights,
    EngagementInsights,
    FeedbackInsights,
    HardwareInsights,
    MarketingInsights,
    TriggerInsights,
    UserInsights, VisitorDensity, VisitorInsights, VisitorMovement
} from "pages/Insights/View";
import ViewZone from './Zone/View';
import ViewFacility from './Facility/View';
import ViewOffer from './Offer/View';
import ViewQrCode from "pages/QrCode/View";
import MembershipPlanList from './MembershipPlan/List';
import MutateMembershipPlan from './MembershipPlan/Mutate';
import ViewMembershipPlan from "pages/MembershipPlan/View";
import MembershipList from './Membership/List';
import MutateMembership from './Membership/Mutate';
import ViewMembership from './Membership/View';
import {BeaconList, MutateBeacon, ViewBeacon} from './Beacon';
import {MutateTicketType, TicketTypeList, ViewTicketType} from './TicketType';
import {ImportTickets, MutateTicket, TicketList, ViewTicket} from './Ticket';
import {AudienceMemberList, MutateAudienceMember, ViewAudienceMember} from "./Audience";
import {GreetingList, MutateGreeting, ViewGreeting} from './Greeting';
import {MutateSpotlight, SpotlightList, ViewSpotlight} from './Spotlight';
import {ArticleList, MutateArticle, ViewArticle} from './Article';
import {FacilityTypeList, MutateFacilityType} from './FacilityType';
import {LinkList, MutateLink} from './Link';
import {ViewAudienceApp} from './AudienceApp';
import {NoteList} from "./Notes";
import {MutateOrganisation, OrganisationList, ViewOrganisation} from './Organisation';
import {MutateSponsorshipTier, SponsorshipTierList, ViewSponsorshipTier} from './SponsorshipTier';
import {MutateSponsorship, SponsorshipList, ViewSponsorship} from './Sponsorship';
import {MutateTrailRating, TrailRatingList, ViewTrailRating} from './TrailRating';
import {MutateTrail, TrailList, ViewTrail} from './Trail';
import {ViewVoucher} from "./Voucher";
import NotAuthorised from "./NotAuthorised";
import {ContactList, MutateContact} from "./Contact";
import {BuildingList, MutateBuilding} from "./Building";
import Support from "./Support";
import ConversationList from "./Conversations/List";
import MutateConversation from "./Conversations/Mutation";
import {TwoFactorAuthRecovery} from "./Login";
import MutateUserSettings from "./UserSettings/Mutate";
import TwoFactorAuthSetup from "./TwoFactorAuth/Mutate/TwoFactorAuthSetup";
import QuizTypeList from "./QuizType/List";
import MutateQuizType from "./QuizType/Mutate";
import InteractionAreaList from "./InteractionArea/List";
import MutateInteractionArea from "./InteractionArea/Mutate";
import ViewDataImport from "./DataImport/View";

function Routes() {
    return (
        <RouteList>
            <Route element={<Authenticated/>}>
                <Route path="/" element={<Dashboard/>}/>

                {/* Insights */}
                <Route path="/insights/app" element={<AppInsights/>}/>
                <Route path="/insights/users" element={<UserInsights/>}/>
                <Route path="/insights/education" element={<EducationInsights/>}/>
                <Route path="/insights/marketing" element={<MarketingInsights/>}/>
                <Route path="/insights/engagement" element={<EngagementInsights/>}/>
                <Route path="/insights/feedback" element={<FeedbackInsights/>}/>
                <Route path="/insights/hardware" element={<HardwareInsights/>}/>
                <Route path="/insights/triggers" element={<TriggerInsights/>}/>
                <Route path="/insights/visitors" element={<VisitorInsights/>}/>
                <Route path="/insights/visitors/density" element={<VisitorDensity/>}/>
                <Route path="/insights/visitors/location" element={<VisitorLocation/>}/>
                <Route path="/insights/visitors/movement" element={<VisitorMovement/>}/>

                {/* Content */}
                <Route path="/greetings" element={<GreetingList/>}/>
                <Route path="/greetings/new" element={<MutateGreeting/>}/>
                <Route path="/greetings/:id" element={<ViewGreeting/>}/>
                <Route path="/greetings/:id/edit" element={<MutateGreeting/>}/>

                <Route path="/spotlights" element={<SpotlightList/>}/>
                <Route path="/spotlights/new" element={<MutateSpotlight/>}/>
                <Route path="/spotlights/:id" element={<ViewSpotlight/>}/>
                <Route path="/spotlights/:id/edit" element={<MutateSpotlight/>}/>
                
                <Route path="/articles" element={<ArticleList/>}/>
                <Route path="/articles/new" element={<MutateArticle/>}/>
                <Route path="/articles/:id" element={<ViewArticle/>}/>
                <Route path="/articles/:id/edit" element={<MutateArticle/>}/>

                <Route path="/notes" element={<NoteList/>}/>

                <Route path="/collections" element={<CollectionList/>}/>
                <Route path="/collections/new" element={<MutateCollection/>}/>
                <Route path="/collections/:id" element={<ViewCollection/>}/>
                <Route path="/collections/:id/edit" element={<MutateCollection/>}/>

                <Route path="/exhibits" element={<ExhibitList/>}/>
                <Route path="/exhibits/new" element={<MutateExhibit/>}/>
                <Route path="/exhibits/:id" element={<ViewExhibit/>}/>
                <Route path="/exhibits/:id/edit" element={<MutateExhibit/>}/>

                <Route path="/exhibit-types" element={<ExhibitTypeList/>}/>
                <Route path="/exhibit-types/new" element={<MutateExhibitType/>}/>
                <Route path="/exhibit-types/:id/edit" element={<MutateExhibitType/>}/>

                <Route path="/fact-templates" element={<FactTemplateList/>}/>
                <Route path="/fact-templates/new" element={<MutateFactTemplate/>}/>
                <Route path="/fact-templates/:id/edit" element={<MutateFactTemplate/>}/>

                <Route path="/trail-ratings" element={<TrailRatingList/>}/>
                <Route path="/trail-ratings/new" element={<MutateTrailRating/>}/>
                <Route path="/trail-ratings/:id" element={<ViewTrailRating/>}/>
                <Route path="/trail-ratings/:id/edit" element={<MutateTrailRating/>}/>

                <Route path="/trails" element={<TrailList/>}/>
                <Route path="/trails/new" element={<MutateTrail/>}/>
                <Route path="/trails/:id" element={<ViewTrail/>}/>
                <Route path="/trails/:id/edit" element={<MutateTrail/>}/>

                <Route path="/links" element={<LinkList/>}/>
                <Route path="/links/new" element={<MutateLink/>}/>
                <Route path="/links/:id/edit" element={<MutateLink/>}/>

                {/* Sponsorship */}
                <Route path="/sponsorship-tiers" element={<SponsorshipTierList/>}/>
                <Route path="/sponsorship-tiers/new" element={<MutateSponsorshipTier/>}/>
                <Route path="/sponsorship-tiers/:id" element={<ViewSponsorshipTier/>}/>
                <Route path="/sponsorship-tiers/:id/edit" element={<MutateSponsorshipTier/>}/>

                <Route path="/sponsorships" element={<SponsorshipList/>}/>
                <Route path="/sponsorships/new" element={<MutateSponsorship/>}/>
                <Route path="/sponsorships/:id" element={<ViewSponsorship/>}/>
                <Route path="/sponsorships/:id/edit" element={<MutateSponsorship/>}/>
                
                {/* Events */}
                <Route path="/events" element={<EventSchedule/>}/>
                <Route path="/events/new" element={<MutateEvent/>}/>
                <Route path="/events/:id" element={<ViewEvent/>}/>
                <Route path="/events/:id/edit" element={<MutateEvent/>}/>

                <Route path="/event-types" element={<EventTypeList/>}/>
                <Route path="/event-types/new" element={<MutateEventType/>}/>
                <Route path="/event-types/:id/edit" element={<MutateEventType/>}/>

                {/* Education */}
                {/*<Route path="/lesson-plans" element={<LessonPlanList/>}/>*/}
                <Route path="/lesson-plans/new" element={<MutateLessonPlan/>}/>
                <Route path="/lesson-plans/:id" element={<ViewLessonPlan/>}/>
                <Route path="/lesson-plans/:id/edit" element={<MutateLessonPlan/>}/>

                <Route path="/quiz-types" element={<QuizTypeList />}/>
                <Route path="/quiz-types/new" element={<MutateQuizType />}/>
                <Route path="/quiz-types/:id/edit" element={<MutateQuizType />}/>

                <Route path="/quizzes" element={<QuizList/>}/>
                <Route path="/quizzes/new" element={<MutateQuiz/>}/>
                <Route path="/quizzes/:id" element={<ViewQuiz/>}/>
                <Route path="/quizzes/:id/edit" element={<MutateQuiz/>}/>

                {/* Audience */}
                <Route path="/audience-app" element={<ViewAudienceApp/>}/>

                <Route path="/audience" element={<AudienceMemberList/>}/>
                <Route path="/audience/new" element={<MutateAudienceMember/>}/>
                <Route path="/audience/:id" element={<ViewAudienceMember/>}/>
                <Route path="/audience/:id/edit" element={<MutateAudienceMember/>}/>

                <Route path="/membership-plans" element={<MembershipPlanList/>}/>
                <Route path="/membership-plans/new" element={<MutateMembershipPlan/>}/>
                <Route path="/membership-plans/:id" element={<ViewMembershipPlan/>}/>
                <Route path="/membership-plans/:id/edit" element={<MutateMembershipPlan/>}/>

                <Route path="/memberships" element={<MembershipList/>}/>
                <Route path="/memberships/new" element={<MutateMembership/>}/>
                <Route path="/memberships/:id" element={<ViewMembership/>}/>
                <Route path="/memberships/:id/edit" element={<MutateMembership/>}/>

                <Route path="/ticket-types" element={<TicketTypeList/>}/>
                <Route path="/ticket-types/new" element={<MutateTicketType/>}/>
                <Route path="/ticket-types/:id" element={<ViewTicketType/>}/>
                <Route path="/ticket-types/:id/edit" element={<MutateTicketType/>}/>

                <Route path="/tickets" element={<TicketList/>}/>
                <Route path="/tickets/new" element={<MutateTicket/>}/>
                <Route path="/tickets/import" element={<ImportTickets/>}/>
                <Route path="/tickets/:id" element={<ViewTicket/>}/>
                <Route path="/tickets/:id/edit" element={<MutateTicket/>}/>

                <Route path="/audience-segments" element={<AudienceSegmentList/>}/>
                <Route path="/audience-segments/new" element={<MutateAudienceSegment/>}/>
                <Route path="/audience-segments/:id" element={<ViewAudienceSegment/>}/>
                <Route path="/audience-segments/:id/edit" element={<MutateAudienceSegment/>}/>

                <Route path="/offers" element={<OfferList/>}/>
                <Route path="/offers/new" element={<MutateOffer/>}/>
                <Route path="/offers/:id" element={<ViewOffer/>}/>
                <Route path="/offers/:id/edit" element={<MutateOffer/>}/>

                <Route path="/vouchers/:id" element={<ViewVoucher/>}/>

                <Route path="/messages" element={<MessageList/>}/>
                <Route path="/messages/new" element={<MutateMessage/>}/>
                <Route path="/messages/:id" element={<ViewMessage/>}/>
                <Route path="/messages/:id/edit" element={<MutateMessage/>}/>

                {/* Contacts */}
                <Route path="/contacts" element={<ContactList/>}/>
                <Route path="/contacts/new" element={<MutateContact/>}/>
                <Route path="/contacts/:id/edit" element={<MutateContact/>}/>

                {/* Experiences */}
                <Route path="/frames" element={<FrameList/>}/>
                <Route path="/frames/new" element={<MutateFrame/>}/>
                <Route path="/frames/:id" element={<ViewFrame/>}/>
                <Route path="/frames/:id/edit" element={<MutateFrame/>}/>

                <Route path="/achievements" element={<AchievementList/>}/>
                <Route path="/achievements/new" element={<MutateAchievement/>}/>
                <Route path="/achievements/:id/edit" element={<MutateAchievement/>}/>

                {/* Locations */}
                <Route path="/site-map" element={<SiteMap/>}/>
                <Route path="/sites" element={<SiteList/>}/>
                <Route path="/sites/new" element={<MutateSite/>}/>
                <Route path="/sites/:id" element={<ViewSite/>}/>
                <Route path="/sites/:id/edit" element={<MutateSite/>}/>

                <Route path="/zones" element={<ZoneList/>}/>
                <Route path="/zones/new" element={<MutateZone/>}/>
                <Route path="/zones/:id" element={<ViewZone/>}/>
                <Route path="/zones/:id/edit" element={<MutateZone/>}/>

                <Route path="/buildings" element={<BuildingList/>}/>
                {/*<Route path="/buildings/new" element={<MutateBuilding/>}/>*/}
                <Route path="/buildings/:id/edit" element={<MutateBuilding/>}/>

                <Route path="/interaction-areas" element={<InteractionAreaList/>}/>
                <Route path="/interaction-areas/new" element={<MutateInteractionArea/>}/>
                <Route path="/interaction-areas/:id/edit" element={<MutateInteractionArea/>}/>

                <Route path="/facility-types" element={<FacilityTypeList/>}/>
                <Route path="/facility-types/new" element={<MutateFacilityType/>}/>
                <Route path="/facility-types/:id/edit" element={<MutateFacilityType/>}/>

                <Route path="/facilities" element={<FacilityList/>}/>
                <Route path="/facilities/new" element={<MutateFacility/>}/>
                <Route path="/facilities/:id" element={<ViewFacility/>}/>
                <Route path="/facilities/:id/edit" element={<MutateFacility/>}/>

                {/* Hardware */}
                <Route path="/beacons" element={<BeaconList/>}/>
                <Route path="/beacons/new" element={<MutateBeacon/>}/>
                <Route path="/beacons/:id" element={<ViewBeacon/>}/>
                <Route path="/beacons/:id/edit" element={<MutateBeacon/>}/>

                {/*<Route path="/objects" element={<PhysicalObjectList/>}/>*/}
                {/*<Route path="/objects/new" element={<MutatePhysicalObject/>}/>*/}
                {/*<Route path="/objects/:id/edit" element={<MutatePhysicalObject/>}/>*/}

                <Route path="/qr-codes" element={<QrCodeList/>}/>
                <Route path="/qr-codes/new" element={<MutateQrCode/>}/>
                <Route path="/qr-codes/:id" element={<ViewQrCode/>}/>
                <Route path="/qr-codes/:id/edit" element={<MutateQrCode/>}/>

                {/* Triggers */}
                <Route path="/triggers" element={<TriggerList/>}/>
                <Route path="/triggers/new" element={<MutateTrigger/>}/>
                <Route path="/triggers/:id" element={<ViewTrigger/>}/>
                <Route path="/triggers/:id/edit" element={<MutateTrigger/>}/>

                {/* Documents */}
                <Route path="/documents" element={<DocumentList/>}/>
                <Route path="/documents/new" element={<MutateDocument/>}/>
                <Route path="/documents/:id/edit" element={<MutateDocument/>}/>

                {/* Users */}
                <Route path="/users" element={<UserList/>}/>
                <Route path="/users/new" element={<MutateUser/>}/>
                <Route path="/users/:id/edit" element={<MutateUser/>}/>

                {/* Organisations */}
                <Route path="/organisations" element={<OrganisationList/>}/>
                <Route path="/organisations/new" element={<MutateOrganisation/>}/>
                <Route path="/organisations/:id" element={<ViewOrganisation/>}/>
                <Route path="/organisations/:id/edit" element={<MutateOrganisation/>}/>

                {/* Settings */}
                <Route path="/settings" element={<MutateSettings/>}/>

                {/* Support */}
                <Route path="/support" element={<Support/>}/>

                {/* Conversations */}
                <Route path="/conversations" element={<ConversationList/>}/>
                <Route path="/conversations/new" element={<MutateConversation/>}/>
                <Route path="/conversations/:id" element={<MutateConversation/>}/>

                {/* Data Imports */}
                <Route path="/imports/:id" element={<ViewDataImport/>}/>

                {/* User Settings */}
                <Route path="/user-settings" element={<MutateUserSettings/>}/>
                <Route path="/two-factor-auth-setup" element={<TwoFactorAuthSetup/>}/>
            </Route>

            <Route element={<Unauthenticated/>}>
                <Route path="/login" element={<Login/>}/>
                <Route path="/two-factor" element={<TwoFactorAuthChallenge/>}/>
                <Route path="/two-factor-recovery" element={<TwoFactorAuthRecovery/>}/>
            </Route>

            <Route element={<Uninitialized/>}>
                <Route path="/inactive" element={<OperatorInactive/>}/>
                <Route path="/unknown" element={<OperatorUnknown/>}/>
                <Route path="/unauthorised" element={<NotAuthorised/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Route>
        </RouteList>
    );
}

export default Routes;